import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper} from "@mui/material";
import DisplayText from "../RichTextEditor/DisplayText";
import React from "react";
import {FormGroup, Input, Label} from "reactstrap";
import {DataType} from "../../interfaces/release.version.interface";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {UserInterface} from "../../interfaces/user.interface";
import {closeReleaseNotesModal} from "../../actions/userInfo";


const ReleaseNotes = React.memo(() => {
  const userInfo = useAppSelector<UserInterface>((state) => state.userInfo);
  const dispatch = useAppDispatch();
  const { releaseModalOpen, releaseVersion } = userInfo;
  const [skipReleaseNotification, setSkipReleaseNotification] = React.useState(false);
  
  const handleChangeReleaseNotification = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSkipReleaseNotification(event.target.checked);
  }
  
  const handleCloseReleaseNotesModal= (skipReleaseNotification: boolean) => {
    dispatch(closeReleaseNotesModal(skipReleaseNotification));
  }
  
  const handleClose = () => {
    handleCloseReleaseNotesModal(skipReleaseNotification);
  }
  
  return (
    <Dialog open={releaseModalOpen ?? false} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Latest Updates!!</DialogTitle>
      <DialogContent dividers>
        {/* DisplayText component to render the release notes */
          releaseVersion?.dataType === DataType.Html ? (
            <Paper
              style={{
                padding: 16,
                border: '1px solid #ccc',
                maxHeight: '420px',
                overflow: 'auto',
              }}
              dangerouslySetInnerHTML={{ __html: JSON.parse(releaseVersion.releaseNotes) }}
            />
          ) : (releaseVersion ? <DisplayText value={JSON.parse(releaseVersion.releaseNotes)} /> : '')
        }
      </DialogContent>
      <DialogActions>
        <FormGroup check style={{position: 'absolute', left: '15px'}}>
          <Input
            type={'checkbox'}
            checked={skipReleaseNotification}
            onChange={handleChangeReleaseNotification}
            name={"skipReleaseNotification"}
            id={"skipReleaseNotification"}
            style={{width: '20px', height: '20px', marginRight: '5px'}}
          />
          <Label
            check
            for={"skipReleaseNotification"}
            style={{ marginTop: '3px'}}
          >
            Please don't show again until next release.
          </Label>
        </FormGroup>
        <Button onClick={handleClose} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default ReleaseNotes;
